import { User } from 'pages/account/users/shared/user.model';
import { FeedbackCategory } from 'pages/misc/feedback/shared/feedback-category.model';
import { Serializable } from 'core/shared/serializable.model';


export class Feedback extends Serializable {

	public id: string = null;
	public description: string = null;
	public category: string = null;
	public user: User = null;
	public feedbackCategory: FeedbackCategory = null;

	constructor(data: Object = {}) {
		super();
		this.serialize(data);
	}

	get relationships() {
		return {
			user: User,
			feedbackCategory: FeedbackCategory
		};
	}

	get httpData() {
		return {
			description: 		  this.description,
			feedback_category_id: this.feedbackCategory?.id
		};
	}
}
